import {
  FaReact,
  FaNodeJs,
  FaPython,
  FaDatabase,
  FaHtml5,
  FaCss3Alt,
  FaJs,
  FaRobot,
} from 'react-icons/fa';
import { SiOpenai } from 'react-icons/si';
import './index.css';

const technologies = [
  { Icon: FaReact, name: 'React', className: 'react' },
  { Icon: FaNodeJs, name: 'Node.js', className: 'node' },
  { Icon: FaPython, name: 'Python', className: 'python' },
  { Icon: FaRobot, name: 'AI Agents', className: 'agents' },
  { Icon: SiOpenai, name: 'LLMs / RAG', className: 'llm' },
  { Icon: FaDatabase, name: 'Databases', className: 'database' },
  { Icon: FaHtml5, name: 'HTML5', className: 'html' },
  { Icon: FaCss3Alt, name: 'CSS3', className: 'css' },
  { Icon: FaJs, name: 'JavaScript', className: 'js' },
];

const TechStack = () => {
  return (
    <section className="tech-stack">
      <h2 className="section-heading">Tech Stack</h2>
      <p className="section-subheading">
        Full-stack web development, Python, and modern AI tooling for production-ready applications.
      </p>
      <div className="tech-grid">
        {technologies.map(({ Icon, name, className }) => (
          <div key={name} className="tech-card glass-card">
            <Icon className={`tech-icon ${className}`} />
            <span className="tech-name">{name}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TechStack;
